import React from 'react'
import { graphql, Link } from 'gatsby'
import _ from 'lodash'
import MDXRenderer from 'gatsby-mdx/mdx-renderer'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-styled-flexboxgrid'
import { PageLayout } from '../layouts'
import toMarkdown from '../utils/stringToMarkdown'
import * as styles from '../styles/pages/exampleTemplate'
import { TextWrapper } from '../styles/base'

const propTypes = {
  data: PropTypes.shape({
    mdx: PropTypes.object.isRequired
  }).isRequired
}

export default function ExampleTemplate({ data }) {
  const { frontmatter, code } = data.mdx

  return (
    <PageLayout>
      <Helmet>
        <title>{`Aito.ai - ${frontmatter.title}`}</title>
      </Helmet>
      <styles.Container>
        <TextWrapper>
          <styles.Breadcrumb>
            <Link to="/example-gallery">Example gallery</Link>
            <styles.PaddedSpan>/</styles.PaddedSpan>
            {frontmatter.title}
          </styles.Breadcrumb>
        </TextWrapper>
        <TextWrapper>
          <Row>
            <styles.TagCol sm={3} xs={12}>
              <styles.TagHeader>
                Example level
              </styles.TagHeader>
              <styles.TagText>
                {toMarkdown(frontmatter.exampleLevel, { paragraphs: false })}
              </styles.TagText>
              <styles.TagHeader>
                Endpoints
              </styles.TagHeader>
              <styles.TagText>
                {_.map(frontmatter.endpoints, (endpoint, i) => (
                  <styles.Endpoint key={endpoint + i}>
                    {toMarkdown(endpoint, { paragraphs: false })}
                  </styles.Endpoint>))
                }
              </styles.TagText>
              <styles.TagHeader>
                Goal
              </styles.TagHeader>
              <styles.TagText>
                {toMarkdown(frontmatter.goal, { paragraphs: false })}
              </styles.TagText>
              <styles.TagHeader>
                Source code
              </styles.TagHeader>
              <styles.TagText>
                {toMarkdown(frontmatter.sourceCode, { paragraphs: false })}
              </styles.TagText>
              <styles.TagHeader>
                Dataset
              </styles.TagHeader>
              <styles.TagText>
                {toMarkdown(frontmatter.dataset, { paragraphs: false })}
              </styles.TagText>
            </styles.TagCol>
            <Col sm={6} xs={12}>
              <styles.Title>{ frontmatter.title }</styles.Title>
              <MDXRenderer>{code.body}</MDXRenderer>
            </Col>
          </Row>
        </TextWrapper>
      </styles.Container>
    </PageLayout>
  )
}

ExampleTemplate.propTypes = propTypes

export const pageQuery = graphql`
  query ExampleByPath($path: String!) {
    mdx(frontmatter: { path: { eq: $path } }) {
      code {
        body
      }
      frontmatter {
        path
        title
        exampleLevel
        endpoints
        goal
        sourceCode
        dataset
      }
    }
  }
`
